import { Buffer } from 'buffer';

import React, { useEffect, useState } from 'react';
import Markdown from 'react-markdown';

import { useSpdCore } from '../../common/hooks/useSpdCore';

interface ChangeLogExternalViewProps {
  changelogUrl?: string;
}

export const ChangeLogExternalView: React.FC<ChangeLogExternalViewProps> = ({
  changelogUrl,
}) => {
  const spd = useSpdCore();
  const [changelog, setChangelog] = useState<string>();

  useEffect(() => {
    if (changelogUrl) {
      spd.docs
        .getExternalFile(changelogUrl)
        .then(changelog => {
          setChangelog(Buffer.from(changelog.content, 'base64').toString());
        })
        .catch(errorResponse => {
          console.log(errorResponse);
        });
    }
  }, [spd.docs, changelogUrl]);

  return (
    <>
      <div className="d-flex mt-3 ms-10 ">
        <Markdown className="markdown limited-markdown">{changelog}</Markdown>
      </div>
    </>
  );
};
